function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function removeSignFromUrl() {
    var url = window.location.href;
    if(url.indexOf("?#")> 0)
    {
        url = url.replace("?#","#");
        window.location.href = url;
        return;
    }

    var qIndex = url.indexOf("?");
    var sharpIndex = url.indexOf("#");
    if(qIndex>-1 && qIndex < sharpIndex)
    {
        var first = url.substring(0,qIndex);
        var end = url.substring(sharpIndex,url.length);
        var newUrl = first.concat(end);
        window.location.href = newUrl;
        return;
    }

}


(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider
            .state('supplierPanel', {
                parent: 'app',
                url: '/supplierPanel',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/supplier/supplierPanel.html',

                        controller: 'SupplierPanelController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyLocationInfo', {
                parent: 'supplierPanel',
                url: '/companyLocationInfo',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/location-info/company-location-info.html',
                        controller: 'CompanyLocationInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyInfoQuery', function ($stateParams, CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }]

                }
            })
            .state('supplierPanel.companyWorkingTimes', {
                parent: 'supplierPanel',
                url: '/companyWorkingTimes',

                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling.html',
                        controller: 'CompanySchedulingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servant');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyAgreementInfo', {
                parent: 'supplierPanel',
                url: '/companyAgreementInfo',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/agreement-info/company-agreement-info.html',
                        controller: 'CompanyAgreementInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agreementInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companySettingInfo', {
                parent: 'supplierPanel',
                url: '/companySettingInfo/:settingFormSection',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/setting-info/company-setting-info.html',
                        controller: 'CompanySettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('themeSettingInfo');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('currency');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyBankAccountInfo', {
                parent: 'supplierPanel',
                url: '/companyBankAccountInfo',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/bank-account-info/company-bank-account-info.html',
                        controller: 'CompanyBankAccountInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companySocialNetworkInfo', {
                parent: 'supplierPanel',
                url: '/companySocialNetworkInfo?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySocialNetworkInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-infos.html',
                        controller: 'CompanySocialNetworkInfoControllerCustom',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('companySocialNetworkInfo');
                        $translatePartialLoader.addPart('socialNetworkType');
                        $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('supplierPanel.companyCustomSetting', {
                parent: 'supplierPanel',
                url: '/companyCustomSetting',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customSetting.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customSetting/custom-setting.html',
                        controller: 'CustomSettingController',
                        controllerAs: 'vm'
                    }
                },
                // params: {
                //     page: {
                //         value: '1',
                //         squash: true
                //     },
                //     sort: {
                //         value: 'id,asc',
                //         squash: true
                //     },
                //     search: null
                // },
                resolve: {
                    // pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //     return {
                    //         page: PaginationUtil.parsePage($stateParams.page),
                    //         sort: $stateParams.sort,
                    //         predicate: PaginationUtil.parsePredicate($stateParams.sort),
                    //         ascending: PaginationUtil.parseAscending($stateParams.sort),
                    //         search: $stateParams.search
                    //     };
                    // }],
                    entity: ['CompanyInfoQuery', function (CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customSetting');
                         $translatePartialLoader.addPart('company');
                        // $translatePartialLoader.addPart('socialNetworkType');
                        // $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.resourcesListForm', {
                parent: 'supplierPanel',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.resourcesListForm'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/resources/resources-list-form.html',
                        controller: 'ResourcesListFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('resources');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.resources', {
                parent: 'supplierPanel',
                url: '/resources',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.resources'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/resources/resources.html',
                        controller: 'ResourcesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('resources');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companySocialNetworkInfo.new', {
                parent: 'supplierPanel.companySocialNetworkInfo',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-info-dialog.html',
                        controller: 'CompanySocialNetworkInfoDialogControllerCustom',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    orderNumber: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companySocialNetworkInfo', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.companySocialNetworkInfo');
                    });
                }]
            })
            .state('supplierPanel.companySocialNetworkInfo.edit', {
                parent: 'supplierPanel.companySocialNetworkInfo',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-info-dialog.html',
                        controller: 'CompanySocialNetworkInfoDialogControllerCustom',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanySocialNetworkInfo', function (CompanySocialNetworkInfo) {
                                return CompanySocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companySocialNetworkInfo', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.companySocialNetworkInfo.delete', {
                parent: 'supplierPanel.companySocialNetworkInfo',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-social-network-info/company-social-network-info-delete-dialog.html',
                        controller: 'CompanySocialNetworkInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanySocialNetworkInfo', function (CompanySocialNetworkInfo) {
                                return CompanySocialNetworkInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companySocialNetworkInfo', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.generalServiceItem', {
                parent: 'supplierPanel',
                url: '/generalServiceItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item/general-service-item.html',
                        controller: 'GeneralServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.generalServiceItemV2', {
                parent: 'supplierPanel',
                url: '/generalServiceItemV2/{id}',
                data: {
                    authorities: []

                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/general-service-item-v2.html',
                        controller: 'GeneralServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.generalServiceItemEventV2', {
                parent: 'supplierPanel',
                url: '/generalServiceItemEventV2/{id}',
                data: {
                    authorities: []

                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/general-service-item-v2.html',
                        controller: 'GeneralServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {
                                    serviceMode: 'EVENT',
                                    id: null
                                }
                    }]
                }
            })
            .state('supplierPanel.generalServiceItem.view', {
                parent: 'supplierPanel',
                url: '/generalServiceItem/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item/general-service-item.html',
                        controller: 'GeneralServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                        return ServiceItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel.generalServiceItemV2.view', {
                parent: 'supplierPanel',
                url: '/generalServiceItemV2/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/general-service-item.html',
                        controller: 'GeneralServiceItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                        return ServiceItem.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel.serviceItemListV2.delete', {
                parent: 'supplierPanel.serviceItemListV2',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemEventListV2.delete', {
                parent: 'supplierPanel.serviceItemEventListV2',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemEventListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemListV2.copy', {
                parent: 'supplierPanel.serviceItemListV2',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemEventListV2.copy', {
                parent: 'supplierPanel.serviceItemEventListV2',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.serviceItemEventListV2', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.serviceItemList', {
                parent: 'supplierPanel',
                url: '/serviceItemList',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item/service-item-list.html',
                        controller: 'ServiceItemListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.serviceItemListV2', {
                parent: 'supplierPanel',
                url: '/serviceItemListV2' + '-' + ':type',
                data: {
                    authorities: ['ROLE_CATEGORY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servicelist'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/service-item-list-old.html',
                        controller: 'ServiceItemListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel.serviceItemEventListV2', {
                parent: 'supplierPanel',
                url: '/serviceItemEventListV2' + '-' + ':type',
                data: {
                    authorities: ['ROLE_EVENT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servicelist'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/service-item-event-list-v2.html',
                        controller: 'ServiceItemEventListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel.companyServiceCategoryList', {
                parent: 'supplierPanel',
                url: '/company-service-category-list',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-category/company-service-category-list.html',
                        controller: 'CompanyServiceCategoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCategory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyServiceCategoryList.new', {
                parent: 'supplierPanel.companyServiceCategoryList',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/company-service-category-dialog.html',
                        controller: 'CompanyServiceCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    categoryName: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.companyServiceCategoryList');
                    });
                }]
            })
            .state('supplierPanel.companyServiceCategoryList.edit', {
                parent: 'supplierPanel.companyServiceCategoryList',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/company-service-category-dialog.html',
                        controller: 'CompanyServiceCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.companyServiceCategoryList.delete', {
                parent: 'supplierPanel.companyServiceCategoryList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
                        controller: 'ServiceCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.companyInfo', {
                parent: 'supplierPanel',
                url: '/companyInfo',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company/company-info.html',
                        controller: 'CompanyInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                    //entity: ['$stateParams', 'Company', function ($stateParams, Company) {
                    //    return Company.get({id: $stateParams.id}).$promise;
                    //}]
                }
            })
            .state('supplierPanel.orderBagTest', {
                parent: 'supplierPanel',
                url: '/orderBagTest',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-test.html',
                        controller: 'OrderBagServiceItemTestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'OrderBagServiceItemCustom', function ($stateParams, OrderBagServiceItemCustom) {
                        //return OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities(3633).query();
                        return {
                            status: 0,
                            subtotalServicePrice: 1,
                            subtotalOaptionPrice: 1,
                            subtotalVAT: 1,
                            subtotalDiscount: 1,
                            totalRowPrice: 1,
                            id: null,
                            orderBagServiceItemDtail: [],
                            serviceItemId: 1427

                        };
                    }]
                    ,
                    timeSession: ['ServiceTimeSession', function (ServiceTimeSession) {
                        return ServiceTimeSession.get({id: 1651}).$promise;
                    }
                    ]
                }
            })
            .state('supplierPanel.orderBag', {
                parent: 'supplierPanel',
                url: '/orderBag',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-list.html',
                        controller: 'OrderBagServiceItemListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.orderBagTest.edit', {
                parent: 'supplierPanel',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag-service-item/order-bag-service-item-test.html',
                        controller: 'OrderBagServiceItemTestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagServiceItemCustom', function ($stateParams, OrderBagServiceItemCustom) {
                        return OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities($stateParams.id).query();
                    }]
                    ,
                    timeSession: ['ServiceTimeSession', function (ServiceTimeSession) {
                        return ServiceTimeSession.get({id: 1651}).$promise;
                    }
                    ]
                }
            })
            .state('supplierPanel.testServices', {
                parent: 'supplierPanel',
                url: '/testServices',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/services/testServices/test-services.html',
                        controller: 'TestServiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    //translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //    return $translate.refresh();
                    //}]
                }
            })
            .state('admin-test-services', {
                parent: 'entity',
                url: '/admin-test-services',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'admin-test-services'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/services/testServices/admin-test-services.html',
                        controller: 'TestServiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel.orderBagList', {
                parent: 'supplierPanel',
                url: '/orderBagList?page&sort&search',
                data: {
                    authorities: ['ROLE_USER']
                    //pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/order-bag-list.html',
                        controller: 'OrderBagListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadOnHand'
                        };
                    }

                }
            })
            .state('supplierPanel.reserveList', {
                parent: 'supplierPanel',
                url: '/reserveList?page&sort&search',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/reserve-list.html',
                        controller: 'ReserveListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadOnHand'
                        };
                    }

                }
            })
            .state('supplierPanel.orderBagListAll', {
                parent: 'supplierPanel',
                url: '/orderBagListAll?page&sort&search',
                data: {
                    authorities: ['ROLE_USER']
                    //pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/order-bag-list.html',
                        controller: 'OrderBagListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadAll'
                        };
                    }
                }
            })
            .state('supplierPanel.orderBagWithParameter', {
                parent: 'supplierPanel',
                url: '/orderBagWithParameter/{serviceItemId}/{timeSessionId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })
            .state('supplierPanel.orderBagWithDateRangeParameter', {
                parent: 'supplierPanel',
                url: '/orderBagWithParameter/{serviceItemId}/{start_date}/{end_date}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })
            .state('supplierPanel.reserve', {
                parent: 'supplierPanel',
                url: '/reserve/{serviceItemId}/{start_date}/{end_date}/{servantId}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader','OrderBagCustom', function ($translate, $translatePartialLoader,OrderBagCustom) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            .state('supplierPanel.orderBagWithCustomerParameter', {
                parent: 'supplierPanel',
                url: '/orderBagWithCustomerParameter/{customerId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/order-bag/upsert-order-bag.html',
                        controller: 'UpsertOrderBagController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })


            .state('supplierPanel.scheduling', {
                parent: 'supplierPanel',
                url: '/scheduling/{id}',

                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/schedule-info/scheduling/scheduling.html',
                        controller: 'SchedulingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.schedulingv2', {
                parent: 'supplierPanel',
                url: '/schedulingv2/{id}',

                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/schedule-info/scheduling/scheduling-v2.html',
                        controller: 'SchedulingV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            // .state('supplierPanel.companyCustomer', {
            //     parent: 'supplierPanel',
            //     url: '/company-customer-list',
            //     data: {
            //         authorities: ['ROLE_USER'],
            //         pageTitle: 'tikonApp.companyCustomer.home.title'
            //     },
            //     views: {
            //         'subcontent': {
            //             templateUrl: 'app/entities/company-customer/company-customers-list.html',
            //             controller: 'CompanyCustomerListController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('companyCustomer');
            //             $translatePartialLoader.addPart('customer');
            //             $translatePartialLoader.addPart('customerStatus');
            //             $translatePartialLoader.addPart('personInfo');
            //             $translatePartialLoader.addPart('global');
            //             $translatePartialLoader.addPart('scheduleType');
            //
            //             return $translate.refresh();
            //         }]
            //     }
            // })

            .state('supplierPanel.companyCustomer', {
                parent: 'supplierPanel',
                url: '/company-customer-list',
                data: {
                    authorities: ['ROLE_CUSTOMER_MANAGER'],
                    pageTitle: 'tikonApp.companyCustomer.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers-list.html',
                        controller: 'CompanyCustomerListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('customerStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleType');

                        return $translate.refresh();
                    }]
                }
            })



            .state('supplierPanel.deleteCompanyCustomer', {
                parent: 'supplierPanel.companyCustomer',
                url: '/company-customer-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyCustomer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.companyPaymentLogList', {
                parent: 'supplierPanel',
                url: '/companyPaymentLog',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-list.html',
                        controller: 'CompanyPaymentLogListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyAllPaymentLogList', {
                parent: 'supplierPanel',
                url: '/companyAllPaymentLog',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-all-payment-log-list.html',
                        controller: 'CompanyAllPaymentLogListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.dashboard', {
                parent: 'supplierPanel',
                url: '/dashboard',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'supplierPanel.sideMenu.dashboard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/main/report.main_dashboard.html',
                        controller: 'MainDashboardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('newsType');
                        removeSignFromUrl();
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.setting', {
                parent: 'supplierPanel',
                url: '/setting',
                data: {
                    authorities: ['ROLE_COMPANY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.setting'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/setting/setting.html',
                        controller: 'SettingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('settingInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.partialFormPersonInfo', {
                parent: 'supplierPanel',
                url: '/userProfile',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.userProfile'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/userprofile/user-profiles.html',
                        controller: 'UserProfileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {


                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('gender');
                        $translatePartialLoader.addPart('locationInfo');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['UserProfileQuery', function (UserProfileQuery) {
                        return UserProfileQuery.getCurrentPersonInfo().query();
                    }]
                }

            })
            .state('supplierPanel.password', {
                parent: 'supplierPanel',
                url: '/password',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.password'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/account/password/password.html',
                        controller: 'PasswordController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {


                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }]
                    // ,
                    // entity: ['UserProfileQuery', function (UserProfileQuery) {
                    //     return UserProfileQuery.getCurrentPersonInfo().query();
                    // }]
                }

            })

            .state('supplierPanel.companySubscriptionStatus', {
                parent: 'supplierPanel',
                url: '/companySubscriptionStatus',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierpanel.sideMenu.companySubscriptionStatus'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-view.html',
                        controller: 'CompanySubscriptionStatusViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel.companySmsPackageStatus', {
                parent: 'supplierPanel',
                url: '/companySmsPackageStatus',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.sms_package_status'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-sms-package-status-view.html',
                        controller: 'CompanySmsPackageStatusViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel.purchaseSubscription', {
                parent: 'supplierPanel',
                url: '/{id}/purchaseSubscription',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/purchase-subscription.html',
                        controller: 'PurchaseSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('supplierCoupon');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'SubscriptionPackage', function ($stateParams, SubscriptionPackage) {

                        if ($stateParams.id != '')

                        return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.confirmSubscription', {
                parent: 'supplierPanel',
                url: '/confirmSubscription?Authority&Status',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/confirm-subscription.html',
                        controller: 'ConfirmSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'CompanySubscriptionStatusCustom', 'Auth', '$state', function ($stateParams, CompanySubscriptionStatusCustom, Auth, $state) {


                        var refid=getParameterByName('refid');
                        var clientrefid=getParameterByName('clientrefid');


                        //jibimo
                        var trx=getParameterByName('trx');
                        var status=getParameterByName('status');
                        var state_code=getParameterByName('state_code');

                        if ($stateParams.Authority != '' && $stateParams.Status == 'OK') {


                            return CompanySubscriptionStatusCustom.confirmSubscription($stateParams.Authority).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });

                        }
                        else if(refid && clientrefid && refid>1)
                        {
                            return CompanySubscriptionStatusCustom.confirmSubscription(clientrefid,refid).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });
                        }
                        else if(trx && status && state_code && status ==1 && state_code == 99 ) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(trx).query(function () {
                            });
                        }
                        else{
                            return null;
                        }


                    }]
                }
            })
            .state('supplierPanel.companySubscriptionStatusV2', {
                parent: 'supplierPanel',
                url: '/companySubscriptionStatusV2',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.subscription'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-view-v2.html',
                        controller: 'CompanySubscriptionStatusViewV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('packageFeatureList');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        // removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel.companySubscriptionStatusEvent', {
                parent: 'supplierPanel',
                url: '/companySubscriptionStatusEvent',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.supplierpanel.sideMenu.companySubscriptionStatus'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-view-event.html',
                        controller: 'CompanySubscriptionStatusViewEventController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })

            .state('supplierPanel.agentCompanyList', {
                parent: 'supplierPanel',
                url: '/agentCompanyList',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/agent-request/company-list.html',
                        controller: 'AgentCompanyListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('agentRequest');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.agentCompanyList.new', {
                parent: 'supplierPanel.agentCompanyList',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-request/agent-request-dialog.html',
                        controller: 'AgentRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    agentRequestType: null,
                                    createDate: null,
                                    requestMessage: null,
                                    suggestedCommision: null,
                                    replyDate: null,
                                    replyMessage: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.agentCompanyList', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.agentCompanyList');
                    });
                }]
            })
            .state('supplierPanel.agentSupplierAccessList', {
                parent: 'supplierPanel',
                url: '/agentSupplierAccessList',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/agent-access-info/set-agent-access-infos.html',
                        controller: 'SetAgentAccessInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('agentSupplierContract');
                        $translatePartialLoader.addPart('agentAccessInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.agentSupplierAccessList.mapServices', {
                parent: 'supplierPanel.agentSupplierAccessList',
                url: '/mapServices/{id}',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'AgentSupplierContractCustom', function ($stateParams, $state, $uibModal, AgentSupplierContractCustom) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-access-info/upsert-agent-access-dialog.html',
                        controller: 'UpsertAgentAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {

                                return AgentSupplierContractCustom.getAgentSupplierWithAllAccessById($stateParams.id).get().$promise;
                            }
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.agentSupplierAccessList', null, {reload: true});
                    }, function () {
                        $state.go('supplierPanel.agentSupplierAccessList');
                    });
                }]
            })
            .state('supplierPanel.conversationList', {
                parent: 'supplierPanel',
                url: '/conversationList',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/conversation/conversation-list.html',
                        controller: 'ConversationListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('conversation');
                        $translatePartialLoader.addPart('conversationStatusType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.conversationList.edit', {
                parent: 'supplierPanel.conversationList',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPPLIER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

                    $uibModal.open({
                        templateUrl: 'app/entities/conversation/conversation-custom-dialog.html',
                        controller: 'ConversationCustomDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Conversation', function (Conversation) {
                                return Conversation.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.conversationList', null, {reload: 'supplierPanel.conversationList'});
                    }, function () {
                        $state.go('supplierPanel.conversationList', null, {reload: 'supplierPanel.conversationList'});
                    });
                }]
            })
            .state('supplierPanel.timeBoard', {
                parent: 'supplierPanel',
                url: '/timeBoard',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/time-board.html',
                        controller: 'TimeBoardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.calendar', {
                parent: 'supplierPanel',
                url: '/calendar',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/book-calendar.template.html',
                        controller: 'BookCalendarController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.calendar.servantExceptionTimes', {
                parent: 'supplierPanel.calendar',
                url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal','$rootScope','Principal', function($stateParams, $state, $uibModal,$rootScope,Principal) {

                    var multiServant = true;
                    Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
                        multiServant = !has;
                    });

                    var availabilityMode = $stateParams.availabilityMode;
                    var defaultServantId = $stateParams.defaultServantId;
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
                        controller: 'ServantExceptionDurationController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('scheduleInfo');

                                return $translate.refresh();
                            }],
                            entity: (function () {
                                return {
                                    defaultServantId: defaultServantId,
                                    availabilityMode:availabilityMode,
                                    canSelectServant:multiServant

                                };
                            })

                        }
                    });


                    $rootScope.modalInstance.result.then(function() {
                        $state.go( 'supplierPanel.calendar', null, { reload: true });
                        $rootScope.modalInstance.dismiss('cancel');
                    }, function() {
                        $state.go('supplierPanel.calendar');
                    });
                }]

            })

            .state('supplierPanel.reportexport', {
                parent: 'supplierPanel',
                url: '/reportexport',
                data: {
                    authorities: ['ROLE_REPORT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.reports'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/reports/report-export.html',
                        controller: 'ReportExportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('reportExport');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.reportexport.orderbag_list_by_service', {
                parent: 'supplierPanel.reportexport',
                url: '/orderbag_list_by_service',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/orderbag_list_by_service/orderbag_list_by_service.html',
                        controller: 'OrderbagListByServiceController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.orderbag_list_by_service', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reportexport.financial_by_customer', {
                parent: 'supplierPanel.reportexport',
                url: '/financial_by_customer',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/financial_by_customer/financial_by_customer.html',
                        controller: 'FinancialByCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.financial_by_customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reserve_v2', {
                parent: 'supplierPanel',
                url: '/reserve_v2',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })

            .state('supplierPanel.reserve_v2.newCompanyCustomerPopUp', {
                parent: 'supplierPanel.reserve_v2',
                url: '/newCompanyCustomerPopUp',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {

                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                        controller: 'CompanyCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {

                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                // $translatePartialLoader.addPart('company');
                                $translatePartialLoader.addPart('personInfo');
                                // $translatePartialLoader.addPart('serviceItem');
                                // $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }],
                            entity: function () {

                                return {
                                    // title: null,
                                    // level: null,

                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('^', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reportexport.reserve_count_by_parent_id', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_count_by_parent_id',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/province_branch_service_date_count/province_branch_service_date_count.html',
                        controller: 'ReserveCountByParentIdController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_count_by_parent_id', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reserveWithCustomerParameter', {
                parent: 'supplierPanel',
                url: '/reserveWithCustomerParameter/{customerId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                views: {
                    'subcontent': {

                        templateUrl: 'app/entities/reserve/new-reserve.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }
                    //,
                    //formMode: ['$stateParams', function ($stateParams) {
                    //    return {
                    //        mode: 'insertFromCalendar',
                    //        serviceItemId: $stateParams.serviceItemId,
                    //        timeSessionId: $stateParams.timeSessionId,
                    //    }
                    //    ;
                    //}
                    //]

                }
            })

            .state('supplierPanel.reportexport.reserve_list_dtail_report', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_list_dtail_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListDtailReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.reportexport.reserve_list_summary_report', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_list_summary_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListSummaryReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.reportexport.reserve_list_summary_with_payment_report', {
                parent: 'supplierPanel.reportexport',
                url: '/reserve_list_summary_with_payment_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_summary_with_payment_report/reserve_list_summary_with_payment_report.html',
                        controller: 'ReserveListSummaryWithPaymentReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.reserve_list_summary_with_payment_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel.reportexport.sum_of_reserve_count', {
                parent: 'supplierPanel.reportexport',
                url: '/sum_of_reserve_count',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/sum_of_reserve_count/sum_of_reserve_count.html',
                        controller: 'SumOfReserveCountController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel.reportexport.sum_of_reserve_count', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.accountClearingList', {
                parent: 'supplierPanel',
                url: '/accountClearingList',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-requests.html',
                        controller: 'AccountClearingRequestListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.accountClearingDetail', {
                parent: 'supplierPanel',
                url: '/accountClearingDetail/detail/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-detail.html',
                        controller: 'AccountClearingRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.eventItemList', {
                parent: 'supplierPanel',
                url: '/eventItemList',
                data: {
                    authorities: ['ROLE_EVENT_MANAGER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-item/event-item-list.html',
                        controller: 'EventItemListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('onlineMeetingType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel.generalEventItem', {
                parent: 'supplierPanel',
                url: '/generalEventItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-item/general-event-item.html',
                        controller: 'GeneralEventItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel.newGeneralEventItem', {
                parent: 'supplierPanel',
                url: '/newGeneralEventItem/{onlineMeetingType}',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-item/general-event-item.html',
                        controller: 'GeneralEventItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {

                        // if ($stateParams.id != '')
                        //     return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })

            .state('supplierPanel.eventItemList.delete', {
                parent: 'supplierPanel.eventItemList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-item/event-item-delete-dialog.html',
                        controller: 'EventItemDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function(ServiceItem) {
                                return ServiceItem.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('supplierPanel.eventItemList', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel.couponList', {
                parent: 'supplierPanel',
                url: '/coupon-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.coupon.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupons-list.html',
                        controller: 'CouponListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.editCoupon', {
                parent: 'supplierPanel',
                url: '/coupon-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupon.html',
                        controller: 'CouponController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('amountTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Coupon', '$stateParams', function (Coupon, $stateParams) {

                        return Coupon.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel.newCoupon', {
                parent: 'supplierPanel',
                url: '/coupon-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupon.html',
                        controller: 'CouponController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        $translatePartialLoader.addPart('amountTypes');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })

            .state('supplierPanel.reserveLimitList', {
                parent: 'supplierPanel',
                url: '/reserve-limit-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.reserveLimit.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limits-list.html',
                        controller: 'ReserveLimitsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.editReserveLimit', {
                parent: 'supplierPanel',
                url: '/reserve-limit-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit.html',
                        controller: 'ReserveLimitController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        return $translate.refresh();
                    }],
                    entity: ['ReserveLimit', '$stateParams', function (ReserveLimit, $stateParams) {

                        return ReserveLimit.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel.newReserveLimit', {
                parent: 'supplierPanel',
                url: '/reserve-limit-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit.html',
                        controller: 'ReserveLimitController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })


            .state('supplierPanel.customerGroupList', {
                parent: 'supplierPanel',
                url: '/customer-group-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customerGroup.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-groups-list.html',
                        controller: 'CustomerGroupListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.newCustomerGroup', {
                parent: 'supplierPanel',
                url: '/customer-group-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-group.html',
                        controller: 'CustomerGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel.editCustomerGroup', {
                parent: 'supplierPanel',
                url: '/customer-group/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-group.html',
                        controller: 'CustomerGroupController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CustomerGroup', '$stateParams', function (CustomerGroup, $stateParams) {

                        return CustomerGroup.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })

            .state('supplierPanel.patternInfoList', {
                parent: 'supplierPanel',
                url: '/pattern-info-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.patternInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/pattern-info/pattern-info-list.html',
                        controller: 'PatternInfoListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('patternInfo');
                        $translatePartialLoader.addPart('patternStatus');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel.editPatternInfo', {
                parent: 'supplierPanel',
                url: '/pattern-info-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/pattern-info/pattern-info.html',
                        controller: 'PatternInfoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('patternInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['PatternInfo', '$stateParams', function (PatternInfo, $stateParams) {

                        return PatternInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel.newPatternInfo', {
                parent: 'supplierPanel',
                url: '/pattern-info-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/pattern-info/pattern-info.html',
                        controller: 'PatternInfoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('patternInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel.accessdeniedV2', {
                parent: 'supplierPanel',
                url: '/access-denied-v2',
                data: {
                    authorities: [],
                    pageTitle: 'global.error.accessDenied'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/supplier-v2/access-denied-v2.html',
                        controller: 'AccessDeniedV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('error');


                        return $translate.refresh();
                    }]
                }
            })

        ;
    }
})();
